import Button from "../Shared/Button";
import Image from "next/image";
import { PortableText } from "@portabletext/react";
import React from "react";
import { useSanityImage } from "../../../config/sanity";

function Tagline({ tagline }: { tagline: Tagline }) {
  const RenderImage = ({ image }: { image: any }) => {
    const imageProps = useSanityImage(image);

    if (!imageProps) {
      return null;
    }

    return (
      <Image
        {...imageProps}
        blurDataURL={image.asset.metadata.lqip}
        alt={image.alt + ", " + image.copyright}
        placeholder="blur"
        priority={true}
        width={1000}
        height={1000}
      />
    );
  };

  return (
    <div className="mx-auto flex flex-col items-center justify-center gap-4 px-4 pb-12 md:min-h-[55vh] md:flex-row md:gap-3 md:py-6">
      <div className="flex w-full items-center justify-center *:-rotate-2 md:w-1/2 lg:w-1/3">
        <RenderImage image={tagline.figure.image} />
      </div>
      <div className="flex h-auto max-w-[65ch] flex-1 flex-col justify-center gap-6 md:w-1/2">
        <div className="flex flex-col gap-3">
          <h1 className="font-serif text-4xl">
            <PortableText value={tagline.title} />
          </h1>
          <h2>{tagline.subtitle}</h2>
        </div>
        {tagline.callToActions && (
          <div className="flex items-baseline gap-3">
            <div className="relative inline-block">
              <span className="absolute -left-2 -top-2 animate-ping text-lg">
                ✨
              </span>
              <span className="absolute -top-3 left-1/3 animate-pulse text-sm [animation-delay:200ms]">
                ✨
              </span>
              <span className="absolute -right-2 -top-2 animate-ping text-lg [animation-delay:400ms]">
                ✨
              </span>
              <span className="absolute -left-5 top-1/2 animate-pulse text-sm [animation-delay:600ms]">
                ✨
              </span>
              <span className="absolute -right-5 top-1/2 animate-pulse text-sm [animation-delay:800ms]">
                ✨
              </span>
              <span className="absolute -bottom-2 -left-2 animate-ping text-lg [animation-delay:300ms]">
                ✨
              </span>
              <span className="absolute -bottom-3 right-1/3 animate-pulse text-sm [animation-delay:500ms]">
                ✨
              </span>
              <span className="absolute -bottom-2 -right-2 animate-ping text-lg [animation-delay:700ms]">
                ✨
              </span>
              <Button
                isActive={true}
                label={tagline.callToActions.callToAction1.name}
                // href={tagline.callToActions.callToAction1.slug.current}
                href="https://www.paypal.com/paypalme/allesbien"
                range={1}
                color="violet"
                ariaLabel={tagline.callToActions.callToAction1.name}
              />
            </div>

            <Button
              isActive={true}
              label={tagline.callToActions.callToAction2.name}
              href={tagline.callToActions.callToAction2.slug.current}
              range={2}
              color="violet"
              ariaLabel={tagline.callToActions.callToAction2.name}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default Tagline;
